import CampaignLogsPure from './CampaignLogsPure'

const CampaignLogs = (props: CampaignLogsProps) => (
  <CampaignLogsPure {...props} />
)

export default CampaignLogs
